module.exports = __webpack_public_path__ + "static/fonts/iconfont.956147bf.woff2";